import QueryProvider from './QueryProvider';
import ThemeProvider from './ThemeProvider';
import KeyboardModeProvider from './KeyboardModeProvider';
import NavigationAidsProvider from './NavigationAidsProvider';
import FormSafetyProvider from './FormSafetyProvider';
import AuthSessionProvider from './AuthSessionProvider';
import AdminSessionProvider from './AdminSessionProvider';
import CustomerPortalSessionProvider from './CustomerPortalSessionProvider';
import CurrencySettingsProvider from './CurrencySettingsProvider';
import { KeyboardProvider } from '../../context/KeyboardProvider';

export default function AppProviders({ children }) {
  return (
    <QueryProvider>
      <AdminSessionProvider>
        <AuthSessionProvider>
          <CustomerPortalSessionProvider>
            <CurrencySettingsProvider>
              <ThemeProvider>
                <FormSafetyProvider>
                  <NavigationAidsProvider>
                    <KeyboardModeProvider>
                      <KeyboardProvider>{children}</KeyboardProvider>
                    </KeyboardModeProvider>
                  </NavigationAidsProvider>
                </FormSafetyProvider>
              </ThemeProvider>
            </CurrencySettingsProvider>
          </CustomerPortalSessionProvider>
        </AuthSessionProvider>
      </AdminSessionProvider>
    </QueryProvider>
  );
}
